import React from 'react';
import { Show, SimpleShowLayout, required, Toolbar, SaveButton, BooleanInput, NumberField, 
  DateField, TabbedForm, FormTab, Edit, Create, EditButton, Filter, List, Datagrid, TextField, 
  TextInput, SelectInput, BooleanField, ReferenceArrayField, SingleFieldList, FunctionField, ChipField,
  NumberInput } from 'react-admin';
import {
  SiteFilter, TopLevelDomainFilter, PublisherFilter, DeviceTypeFilter, ViewabilityFilter,
  PageUrlFilter, CountryFilter, StateFilter, AdSizeFilter, DivIDFilter, BidderFilter, ImpressionTypeFilter
} from './common/filters/Filters';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const utils = require('./components/utils');

const DealTitle = ({ record }) => {
	return <span>Deal {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

const DealFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
        <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{ color: 'white' }} resettable />
        <BooleanInput source="active" defaultValue='true' label="Active" style={{ color: 'white' }} resettable />
    </Filter>
);
const FilterArrayField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (!record.segment || !record.segment[field] || !record.segment[field].values || record.segment[field].values.length<=0) return <div />;
	var arr = record.segment[field].values.split('\n');
	return (
		<div>
	 		<br />
	 		<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
	 			<span>{label}</span>
	 		</label>
	 		<br />
	 		<span className="MuiTypography-root MuiTypography-body2">
	 			{arr.length > 5 ? (arr.splice(0, 5).join(' ') + ' ...') : arr.join(' ')}
	 		</span>
	</div>
	)
}
const FilterListField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (record.segment && record.segment[field] && record.segment[field].values && record.segment[field].values.length>0) return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label}</span>
			</label>
			<ul>
				{record.segment[field].values.map(item => (
					<li key={item}>{item}</li>
				))}
			</ul>
		</div>
	)
	return <div />
}
const checkFilter = (filter) => {
	if (!filter) return false
	if (Array.isArray(filter.values) && filter.values.length > 0)
		return true;
	return false
}
const DealPreview = ({record, ...props}) => {
	return (
		<Show {...props} actions={false}>
			<SimpleShowLayout>
        {props.record.pace != null && <NumberField label="Pace %" source="pace" />}
				<FilterArrayField field='filter_top_level_domain' label='Filter Domains'/>
				<FilterArrayField field='filter_page_url' label='Filter Page URLs'/>
				<FilterListField field='filter_country' label='Filter Countries'/>
				<FilterListField field='filter_state' label='Filter States'/>
				<FilterListField field='filter_device_type' label='Filter Devices'/>
				<FilterArrayField field='filter_adsize' label='Filter Ad Sizes'/>
        {checkFilter(record.segment.filter_bidder) && <ReferenceArrayField source="segment.filter_bidder.values" label="Bidders Filtered" reference="bidders">
					<SingleFieldList>
						<ChipField source="name" />
					</SingleFieldList>
				</ReferenceArrayField>}
				<FilterArrayField field='filter_divid' label='Filter Div IDs'/>
        {<FilterListField field='filter_viewability' label='Filter Viewability' />}
			</SimpleShowLayout>
		</Show>
	)
}
export const DealList = (props) => (
    <List {...props} title="Deals" 
    filter={{ type: 'DEAL' }}
    filters={<DealFilter />} 
    perPage={25} 
    bulkActionButtons={false}>
		<Datagrid rowClick="edit" expand={<DealPreview />}>
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
      <TextField source="deal_id" label="Deal ID" />
			<TextField source="pace" label="Pace %" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<BooleanField source="active" label="Active" />
			<EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);

const useStyles = makeStyles({
  dualGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px'
  },
  
  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  }
});

class CustomToolbar extends React.Component {
  constructor (props) {
    super(props);
    this.parent = props.parent;
  }
  render () {
    return <Toolbar>
      <SaveButton style={{ marginRight: '10px' }} variant='contained' color='primary' {...this.props}/>
      <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
      <TextField source="updated_name" label="" style={{ padding: '10px' }} />
    </Toolbar>;
  }
}
class DealForm extends React.Component {
  render () {
    return (
    <TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
		<FormTab label="Settings">
      <br/>
      <NumberField source="code" label="Deal ID" />
      
      <BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />
      <TextInput source="name" label="Deal Name" style={{ width: '400px' }} validate={required()} helperText="Vanity name of the deal."/>

      <TextInput source="deal_id" label="Deal ID" style={{ width: '400px' }} validate={required()} helperText="Deal ID you have agreed on with the Buyer."/>
      
      <TextInput source="type" label="type" defaultValue='DEAL' disabled style={{ visibility: 'hidden', display: 'none' }}/>
    
      <SelectInput source="pace" label="Pace" initialValue='100' choices={utils.PACES} />

      <NumberInput source="hard_floor" label="Bid Floor" helperText="Bid Floor (USD). Leave blank if not required." />

      <SelectInput source="deal_type" label="Deal Type"
      choices={[
        {id: 'OPEN', name: 'Open'},
        {id: 'EXCLUSIVE', name: 'Exclusive'},
      ]} 
      initialValue="OPEN"/>

      <br/>
      <FunctionField label="Targeting Parameter: " render={record => (record.code)?`nb_deal_${record.code}=1`:''} />
      <br/>
    </FormTab>
        
    <FormTab label="Filters">
      <Box className={this.props.classes.dualGrid} fullWidth record={this.props.record}>
        <Box className={this.props.classes.flexColumn} fullWidth>
          <PublisherFilter {...this.props}/>
          <SiteFilter {...this.props}/>
          <TopLevelDomainFilter {...this.props}/>
          <PageUrlFilter {...this.props}/>
          <CountryFilter {...this.props}/>
          <StateFilter {...this.props}/>
        </Box>
        <Box className={this.props.classes.flexColumn} fullWidth>
          <DivIDFilter {...this.props}/>
          <DeviceTypeFilter {...this.props}/>
          <AdSizeFilter {...this.props}/>
          <BidderFilter hideExclude={true} {...this.props}/>
          <ViewabilityFilter {...this.props}/>
          <ImpressionTypeFilter {...this.props}/>
        </Box>
      </Box>
      <TextInput source="segment.filter_impression_type.match_type" initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
      <BooleanInput source="segment.filter_impression_type.exclude" initialValue={false} disabled style={{ width: '1%', visibility: 'hidden', display: 'none' }} />

    </FormTab>
    </TabbedForm>
    );
  }
}



export const DealEdit = (props) => {
  const classes = useStyles(props);
  return (
    <Edit title={<DealTitle />} {...props}>
      <DealForm formType="edit" permissions={props.permissions} parent={this} classes={classes}/>
    </Edit>
  );
}

export const DealCreate = (props) => {
  const classes = useStyles(props);
  return (
    <Create title="Create Deal" {...props} >
      <DealForm formType="create" permissions={props.permissions} parent={this} classes={classes}/>
    </Create>
  );
}
